import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import mapValues from 'lodash/mapValues';
import groupBy from 'lodash/groupBy';
import { ProfileTypes } from '../Types';
import RoutingService from '../../services/RoutingService';
import TextUtils from '../../utils/TextUtils';
import AuthAPIService from '../../services/API/AuthService';
import AuthService from '../../services/AuthService';
import {
  getImageFile,
  handleAgeSubmission,
  handleGenderSubmission,
  redirectByProfileDetails,
} from './Helper/ProfileActionHelper';
import ProfileService from '../../services/API/ProfileService';
import LocationService from '../../services/LocationService';
import AppConstants from '../../constants/AppConstants';
import { formatError } from '../../services/AppService';
import TelemetryService from '../../services/TelemetryService';
import { upload } from '../../services/API/FileUploadService';
import TelemetryConstants from '../../constants/TelemetryConstants';
import { Navigation } from '../../services/NavigationService';
import UserPrefService from '../../services/UserPrefService';

const DEFAULT_TIMEOUT = 4000;
const ERROR_DOCUMENT_UPLOAD = 'Upload Failed';
// const FB_STATUS_CONNECTED = 'connected';
export default function profileActions(state, dispatch) {
  const _resetError = () => {
    dispatch({ type: ProfileTypes.RESET_ERROR });
  };
  const _resetInfo = () => {
    dispatch({ type: ProfileTypes.RESET_INFO });
  };
  const _resetSuccess = () => {
    dispatch({ type: ProfileTypes.RESET_SUCCESS_MESSAGE });
  };
  const setProfileError = (error, isAutoCancel = true, timeout) => {
    dispatch({ type: ProfileTypes.SET_ERROR, payload: { error: formatError(error) } });
    if (isAutoCancel) {
      setTimeout(() => {
        _resetError();
      }, timeout || DEFAULT_TIMEOUT);
    }
  };
  const setProfileInfo = (info, isAutoCancel = true, timeout) => {
    dispatch({ type: ProfileTypes.SET_INFO, payload: { info } });
    if (isAutoCancel) {
      setTimeout(() => {
        _resetInfo();
      }, timeout || DEFAULT_TIMEOUT);
    }
  };
  const setProfileSuccessMessage = (success, isAutoCancel = true, timeout) => {
    dispatch({ type: ProfileTypes.SET_SUCCESS_MESSAGE, payload: { success } });
    if (isAutoCancel) {
      setTimeout(() => {
        _resetSuccess();
      }, timeout || DEFAULT_TIMEOUT);
    }
  };
  function dispatchAPIProgress(status) {
    dispatch({
      type: ProfileTypes.IS_API_PROGRESS,
      payload: status,
    });
  }
  const toggleEdit = profileType => {
    dispatch({
      type: ProfileTypes.TOGGLE_EDIT_PROFILE,
      payload: profileType,
    });
  };
  const toggleWarning = profileType => {
    dispatch({
      type: ProfileTypes.TOGGLE_WARNING,
      payload: profileType,
    });
  };

  const fetchUserInfo = () => {
    return ProfileService.getUserDetails();
  };

  const getOnBoardingStatus = () => {
    dispatch({
      type: ProfileTypes.IS_API_PROGRESS,
      payload: true,
    });

    fetchUserInfo()
      .then(userData => {
        if (isEmpty(userData)) {
          RoutingService.gotoOnboardLanguageSelection();
          return false;
        }
        dispatch({ type: ProfileTypes.UPDATE_USER_DETAILS, payload: userData });
        return ProfileService.getUserProfile();
      })
      .then(data => {
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });

        if (isEmpty(data)) return false;
        // We are sure that user already logged in. hence setuser here for telemetry
        TelemetryService.setUser();
        return redirectByProfileDetails(data, dispatch);
      })
      .catch(() => {
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
        return false;
      });
  };

  const getUserProfile = cb => {
    dispatchAPIProgress(true);
    ProfileService.getUserProfile()
      .then(profile => {
        dispatchAPIProgress(false);
        dispatch({ type: ProfileTypes.PROFILE_PATCH_RESPONSE, payload: profile });
        cb && cb();
      })
      .catch(error => {
        dispatchAPIProgress(false);
        setProfileError(error);
      });
  };

  function onSelectPreferredLanguage(selectedLanguage) {
    dispatch({ type: ProfileTypes.SELECT_PREFERRED_LANGUAGE, payload: selectedLanguage });
    UserPrefService.storePref({ language: selectedLanguage.value });
    RoutingService.gotoQualification();
  }
  function onChangeUserName(userName) {
    if (!isEmpty(userName) && !TextUtils.isOnlyAlpha(userName)) return;
    dispatch({ type: ProfileTypes.ON_CHANGE_USERNAME, payload: userName });
  }

  function onSubmitUserName() {
    RoutingService.gotoOnboardGenderInput();
  }

  function onSelectGender(gender) {
    dispatch({
      type: ProfileTypes.ON_CHANGE_GENDER,
      payload: gender,
    });
    handleGenderSubmission();
  }
  function onChangeGender(gender) {
    dispatch({
      type: ProfileTypes.ON_CHANGE_GENDER,
      payload: gender,
    });
  }

  function onChangeMobileNumber(number) {
    if (`${number}`.length > 10) return;
    if (`${number}`.length === 10) {
      TelemetryService.sendEvent([
        TelemetryConstants.ONBOARDING,
        TelemetryConstants.MOBILE_NUMBER,
        TelemetryConstants.ACTION_ENTER_MOBILE_NUMBER,
      ]);
    }
    dispatch({ type: ProfileTypes.ON_CHANGE_MOBILE, payload: number });
  }

  function onSubmitMobileNumber(options) {
    !get(options, 'resend', false) &&
      TelemetryService.sendEvent([
        TelemetryConstants.ONBOARDING,
        TelemetryConstants.MOBILE_NUMBER,
        TelemetryConstants.SUBMIT_MOBILE,
      ]);
    dispatch({
      type: ProfileTypes.IS_API_PROGRESS,
      payload: true,
    });

    AuthAPIService.authLogin({
      phoneNumber: `${state.userMobile}`,
      name: state.userName,
    })
      .then(() => {
        dispatchAPIProgress(false);
        TelemetryService.setUser();
        RoutingService.gotoOnboardOTPInput();
      })
      .catch(() => {
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
      });
  }
  const updateProfile = (options, cb) => {
    dispatch({
      type: ProfileTypes.IS_API_PROGRESS,
      payload: true,
    });
    ProfileService.updateProfile(options)
      .then(data => {
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
        if (data) {
          dispatch({ type: ProfileTypes.PROFILE_PATCH_RESPONSE, payload: data });
          cb && cb(data);
        }
      })
      .catch(error => {
        console.log('profile -> error', error);
        dispatch({
          type: ProfileTypes.PROFILE_PATCH_ERROR,
          payload: error,
        });
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
      });
  };
  function onSubmitOTP(otp) {
    TelemetryService.sendEvent([
      TelemetryConstants.ONBOARDING,
      TelemetryConstants.OTP,
      TelemetryConstants.SUBMIT_OTP,
    ]);
    dispatch({
      type: ProfileTypes.IS_API_PROGRESS,
      payload: true,
    });

    AuthAPIService.authOTP({
      phoneNumber: `${state.userMobile}`,
      otp: otp || `${state.userOTP}`,
      name: state.userName,
    })
      .then(data => {
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
        if (data) {
          const {
            cookie: { accessToken, expiry },
          } = data;
          AuthService.setAuthToken({ accessToken, expiry });
          const prefs = UserPrefService.readPref();
          const locale = get(state, 'selectedLanguage.value') || get(prefs, 'language');
          const education = get(state, 'qualification') || get(prefs, 'selectedEducation');
          const salary = get(state, 'selectedSalary', 0) || get(prefs, 'salary', 0);
          if (locale && education && salary) {
            updateProfile(
              {
                userInformation: {
                  locale,
                  education,
                  minSalary: parseInt(salary, 10),
                  source: AppConstants.SOURCE,
                },
              },
              getOnBoardingStatus
            );
          }
          // else if (!isEmpty(locale) && !isEmpty(gender))
          //   updateProfile(
          //     {
          //       userInformation: {
          //         locale,
          //         gender,
          //         age: age ? parseInt(age, 10) : undefined,
          //         source: AppConstants.SOURCE,
          //       },
          //     },
          //     getOnBoardingStatus
          //   );
          else getOnBoardingStatus();
        }
      })
      .catch(error => {
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
        TelemetryService.sendEvent([
          TelemetryConstants.ONBOARDING,
          TelemetryConstants.OTP,
          TelemetryConstants.OTP_ERROR,
        ]);
        setProfileError(error, false);
      });
  }
  function onChangeOTPInput(otp) {
    const { error } = state;
    if (!isEmpty(error)) _resetError();
    if (`${otp}`.length === 4) {
      TelemetryService.sendEvent([
        TelemetryConstants.ONBOARDING,
        TelemetryConstants.MOBILE_NUMBER,
        TelemetryConstants.ACTION_ENTER_OTP,
      ]);
      dispatch({
        type: ProfileTypes.ON_CHANGE_OTP,
        payload: otp,
      });
      setTimeout(() => {
        onSubmitOTP(otp);
      }, 300);
    } else {
      dispatch({
        type: ProfileTypes.ON_CHANGE_OTP,
        payload: otp,
      });
    }
  }

  function onResendOTP() {
    TelemetryService.sendEvent([
      TelemetryConstants.ONBOARDING,
      TelemetryConstants.OTP,
      TelemetryConstants.ACTION_RESEND,
    ]);
    onSubmitMobileNumber({ resend: true });
  }

  const onChangeUserAge = age => {
    dispatch({ type: ProfileTypes.ON_CHANGE_AGE, payload: age });
  };

  const setSelectedCity = (city, callback) => {
    console.log(city);
    dispatch({ type: ProfileTypes.ON_SELECT_CITY, payload: { cityId: city.id, ...city } });
    updateProfile(
      {
        userWorkCity: {
          cityId: city.id,
          source: AppConstants.SOURCE,
        },
      },
      callback
    );
  };

  const onSelectCity = city => {
    dispatch({ type: ProfileTypes.ON_SELECT_CITY, payload: city });
    updateProfile(
      {
        userWorkCity: {
          cityId: city.cityId,
          source: AppConstants.SOURCE,
        },
      },
      () => {
        RoutingService.gotoAreaSelection({ staticContext: { city } });
      }
    );
  };

  const onSelectCityByLocation = fetchCityByLocation => {
    if (!fetchCityByLocation && typeof fetchCityByLocation !== 'function') return;
    dispatch({ type: ProfileTypes.FETCHING_LOCATION, payload: true });
    LocationService.getLocation()
      .then(location => {
        dispatch({ type: ProfileTypes.FETCHING_LOCATION, payload: false });
        return location;
      })
      .then(location => {
        return fetchCityByLocation(location);
      })
      .then(fetchedCity => {
        if (isEmpty(fetchedCity)) return setProfileError('No city found. Please Retry');
        const { id, ...rest } = fetchedCity;
        dispatch({
          type: ProfileTypes.ON_SELECT_CITY,
          payload: { cityId: id, ...rest },
        });
        updateProfile(
          {
            userWorkCity: {
              cityId: id,
              source: AppConstants.SOURCE,
            },
          },
          () => {
            RoutingService.gotoAreaSelection();
          }
        );
        return {};
      })
      .catch(error => {
        dispatch({ type: ProfileTypes.FETCHING_LOCATION, payload: false });
        setProfileError(error, true);
      });
  };

  const onSelectLocalityByLocation = fetchCityByLocation => {
    if (!fetchCityByLocation && typeof fetchCityByLocation !== 'function') return;
    dispatch({ type: ProfileTypes.FETCHING_LOCATION, payload: true });
    LocationService.getLocation()
      .then(location => {
        dispatch({ type: ProfileTypes.FETCHING_LOCATION, payload: false });
        return location;
      })
      .then(location => {
        return fetchCityByLocation(location);
      })
      .then(fetchedCity => {
        if (isEmpty(fetchedCity)) return setProfileError('No city found. Please Retry');
        updateProfile(
          {
            userWorkLocalities: {
              localityIds: fetchedCity.map(item => item.id),
            },
          },
          () => {
            RoutingService.gotoHomeAddress();
          }
        );
        return {};
      })
      .catch(error => {
        dispatch({ type: ProfileTypes.FETCHING_LOCATION, payload: false });
        setProfileError(error, true);
      });
  };

  const onSubmitLocalities = jobLocalities => {
    if (isEmpty(jobLocalities)) return;
    updateProfile(
      {
        userWorkLocalities: {
          localityIds: jobLocalities.map(item => item.id),
        },
      },
      () => {
        RoutingService.gotoHome();
      }
    );
  };

  const onSelectHomeCity = city => {
    updateProfile(
      {
        userLocation: {
          cityId: city.cityId,
          source: AppConstants.SOURCE,
        },
      },
      () => {
        RoutingService.gotoQualification();
      }
    );
  };

  const onSelectHomeByLocation = fetchCityByLocation => {
    if (!fetchCityByLocation && typeof fetchCityByLocation !== 'function') return;
    dispatch({ type: ProfileTypes.FETCHING_LOCATION, payload: true });
    LocationService.getLocation()
      .then(location => {
        dispatch({ type: ProfileTypes.FETCHING_LOCATION, payload: false });
        return location;
      })
      .then(location => {
        return fetchCityByLocation(location);
      })
      .then(fetchedCity => {
        if (isEmpty(fetchedCity)) return setProfileError('No city found. Please Retry');
        const { id } = fetchedCity;
        updateProfile(
          {
            userLocation: {
              cityId: id,
              source: AppConstants.SOURCE,
            },
          },
          () => {
            RoutingService.gotoQualification();
          }
        );
        return {};
      })
      .catch(error => {
        dispatch({ type: ProfileTypes.FETCHING_LOCATION, payload: false });
        setProfileError(error);
      });
  };

  const onSelectQualification = selectedQualification => {
    dispatch({ type: ProfileTypes.ON_SELECT_QUAL, payload: selectedQualification });
    UserPrefService.storePref({ selectedEducation: selectedQualification });
  };

  const onSubmitQualification = () => {
    if (!state.qualification) return;
    RoutingService.gotoSalarySelection();
  };
  const onSelectJobDuration = selectedDuration => {
    dispatch({ type: ProfileTypes.ON_SELECT_JOB_DURATION, payload: selectedDuration });
  };

  const onSubmitJobDuration = () => {
    if (!state.jobDuration === '') return;
    updateProfile(
      {
        userInformation: {
          jobUrgency: state.jobDuration,
          source: AppConstants.SOURCE,
        },
      },
      () => {
        RoutingService.gotoWorkExperience();
      }
    );
  };

  const onSelectJobCategories = selectedJobCategory => {
    dispatch({ type: ProfileTypes.ON_SELECT_JOB_CATEGORY, payload: selectedJobCategory });
  };

  const onSubmitJobCategories = () => {
    if (isEmpty(state.jobCategories)) return;
    updateProfile(
      {
        userJobCategories: {
          categories: state.jobCategories,
        },
      },
      () => {
        RoutingService.gotoMultipleSkills();
      }
    );
  };

  const onSelectJobLocalities = selected => {
    dispatch({ type: ProfileTypes.ON_SELECT_JOB_LOCALITIES, payload: selected });
  };

  const onSubmitWorkExperience = (exp, cb) => {
    if (isEmpty(exp)) return;
    updateProfile(
      {
        userWorkExperiences: {
          userWorkExperiences: [exp],
        },
      },
      data => {
        dispatch({ type: ProfileTypes.UPDATE_USER_EXP, payload: get(data, 'userWorkExperiences') });
        cb && cb();
      }
    );
  };
  const onContinueWorkExp = () => {
    RoutingService.gotoJobChoice();
  };

  const onSelectMaritalStatus = status => {
    updateProfile(
      {
        userInformation: {
          married: status,
          source: AppConstants.SOURCE,
        },
      },
      () => {
        RoutingService.gotoJoiningDuration();
      }
    );
  };

  const onSelectSkill = selected => {
    dispatch({ type: ProfileTypes.ON_SELECT_SKILLS, payload: selected });
  };

  const onSubmitSkills = () => {
    const { userSkills } = state;
    if (!userSkills) return;
    const grouped = mapValues(groupBy(userSkills, 'type'), clist => clist.map(ca => ca.value));
    updateProfile(
      {
        userInformation: {
          qualifications: { skills: [], ownerships: [], documents: [], languages: [], ...grouped },
          source: AppConstants.SOURCE,
        },
      },
      () => {
        RoutingService.gotoJobPreference();
      }
    );
  };

  const onSelectJobType = selected => {
    dispatch({ type: ProfileTypes.ON_SELECT_JOB_TYPE, payload: selected });
  };

  const onSelectJobPref = selected => {
    dispatch({ type: ProfileTypes.ON_SELECT_JOB_PREF, payload: selected });
  };

  const onSubmitJobPref = () => {
    const {
      userJobPref: { jobType, prefs: shiftPreference },
    } = state;
    if (isEmpty(jobType) || isEmpty(shiftPreference)) return;
    const payload = {
      userInformation: {
        jobPreference: { jobType, shiftPreference },
        source: AppConstants.SOURCE,
      },
    };

    updateProfile(payload, () => {
      RoutingService.gotoConnectMitras();
    });
  };

  const uploadProfilePicture = (source, cb) => {
    dispatch({
      type: ProfileTypes.IS_API_PROGRESS,
      payload: true,
    });

    getImageFile(source, false, true)
      .then(blob => {
        upload(blob.file)
          .then(data => {
            const payload = {
              userInformation: {
                selfieUrl: data.fileURL,
                source: AppConstants.SOURCE,
              },
            };
            updateProfile(payload, cb);
          })
          .catch(error => setProfileError(error))
          .finally(() => {
            AuthService.setSelfieSkipped();
          });
      })
      .catch(error => setProfileError(error));
  };

  const uploadDocument = (source, cb) => {
    dispatch({
      type: ProfileTypes.IS_API_PROGRESS,
      payload: true,
    });
    getImageFile(source, false, false)
      .then(blob => {
        cb && cb(blob);
      })
      .catch(error => setProfileError(error))
      .finally(() => {
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
      });
  };
  const storePendingDocs = (doc, type, cb) => {
    dispatch({ type: ProfileTypes.PENDING_DOCS, payload: { doc, type } });
    setProfileSuccessMessage({ detail: 'Document Submitted' }, false);
    cb && cb();
  };

  const removePendingDocs = type => {
    dispatch({ type: ProfileTypes.REMOVE_PENDING_DOC, payload: { type } });
  };
  const submitPendingDocs = (documentDetails, data, cb) => {
    const { pendingDocs } = state;
    const pendingDoc = pendingDocs[documentDetails.type];
    if (pendingDoc) {
      if (!isEmpty(pendingDoc.imageUrl)) {
        const payload = {
          userProof: {
            type: documentDetails.type,
            source: AppConstants.SOURCE,
            imageUrl: pendingDoc.imageUrl,
            otherSideImageUrl: data.fileURL,
          },
        };
        updateProfile(payload, () => {
          setProfileSuccessMessage({ detail: 'Upload Success' }, false);
          cb && cb();
        });
        removePendingDocs(documentDetails.type);
      } else {
        const payload = {
          userProof: {
            type: documentDetails.type,
            source: AppConstants.SOURCE,
            imageUrl: data.fileURL,
            otherSideImageUrl: pendingDoc.otherSideImageUrl,
          },
        };
        updateProfile(payload, () => {
          setProfileSuccessMessage({ detail: 'Upload Success' }, false);
          cb && cb();
        });
        removePendingDocs(documentDetails.type);
      }
    }
  };

  const submitDocument = (documentDetails, cb) => {
    if (isEmpty(documentDetails) || isEmpty(documentDetails.type)) return;
    dispatch({
      type: ProfileTypes.IS_API_PROGRESS,
      payload: true,
    });
    upload(documentDetails.file)
      .then(data => {
        if (documentDetails.isMultiUpload) {
          const { pendingDocs } = state;
          const pendingDoc = pendingDocs[documentDetails.type];
          if (pendingDoc) {
            submitPendingDocs(documentDetails, data, cb);
          } else {
            const doc = {};
            if (documentDetails.isBackImage) {
              doc.otherSideImageUrl = data.fileURL;
              storePendingDocs(doc, documentDetails.type, cb);
            } else {
              doc.imageUrl = data.fileURL;
              storePendingDocs(doc, documentDetails.type, cb);
            }
            dispatch({
              type: ProfileTypes.IS_API_PROGRESS,
              payload: false,
            });
          }

          return;
        }

        const payload = {
          userProof: {
            type: documentDetails.type,
            imageUrl: data.fileURL,
            source: AppConstants.SOURCE,
          },
        };
        updateProfile(payload, () => {
          setProfileSuccessMessage({ detail: 'Upload Success' }, false);
          cb && cb();
        });
      })
      .catch(error => {
        console.log('doc upload error: ', error);
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
        setProfileError(ERROR_DOCUMENT_UPLOAD);
      });
  };

  const fetchJobCategories = () => {
    dispatch({
      type: ProfileTypes.IS_API_PROGRESS,
      payload: true,
    });
    ProfileService.getJobCategories()
      .then(jobCategories => {
        dispatch({ type: ProfileTypes.SET_JOB_CATEGORIES, payload: jobCategories });
      })
      .catch(error => {
        console.log('Fail to fetch Job categories', error);
      })
      .finally(() => {
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
      });
  };

  const fetchRequirements = () => {
    dispatch({
      type: ProfileTypes.IS_API_PROGRESS,
      payload: true,
    });
    ProfileService.fetchRequirements()
      .then(req => {
        dispatch({ type: ProfileTypes.SET_JOB_REQUIREMENTS, payload: req });
      })
      .catch(error => {
        console.log('Fail to fetch Job categories', error);
      })
      .finally(() => {
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
      });
  };

  function submitUserDetails(cb) {
    const { userAge, gender, userName, userMobile } = state;
    if (isEmpty(userName)) return;
    if (isEmpty(gender)) return;
    if (isEmpty(userAge)) return;

    const payload = {
      userInformation: {
        gender,
        age: parseInt(userAge, 10),
        source: AppConstants.SOURCE,
      },
      user: { name: userName, phoneNumber: userMobile },
    };
    updateProfile(payload, () => {
      cb && cb();
    });
  }
  function resetUserDetails() {
    dispatch({
      type: ProfileTypes.RESET_USER_ENTRY,
    });
    Navigation.goBack();
  }

  function showFacebookLoginLoader() {
    dispatch({
      type: ProfileTypes.TOGGLE_FACEBOOK_LOGIN_LOADER,
      payload: true,
    });
  }

  function hideFacebookLoginLoader() {
    dispatch({
      type: ProfileTypes.TOGGLE_FACEBOOK_LOGIN_LOADER,
      payload: false,
    });
  }

  function showLoginOption() {
    dispatch({
      type: ProfileTypes.TOGGLE_LOGIN_OPTION,
      payload: true,
    });
  }

  function hideLoginOption() {
    dispatch({
      type: ProfileTypes.TOGGLE_LOGIN_OPTION,
      payload: false,
    });
    hideFacebookLoginLoader();
  }

  function onSalarySelected(salary) {
    dispatch({
      type: ProfileTypes.SALARY_SELECTED,
      payload: salary,
    });
    UserPrefService.storePref({ salary });
    showLoginOption();
  }
  function handleFacebookLogin(fbResponse) {
    showLoginOption();
    showFacebookLoginLoader();
    const { accessToken: fbToken, email } = fbResponse;

    // if (status !== FB_STATUS_CONNECTED) return;
    if (!fbToken) {
      setProfileError({ detail: 'Failed to Login' }, false);
      // Login FAILURE Sending metrics
      TelemetryService.sendEvent([
        TelemetryConstants.ONBOARDING,
        TelemetryConstants.LOGIN_OPTION,
        TelemetryConstants.FB_FAILED,
      ]);
      hideLoginOption();
      return;
    }
    // Storing email for Telemetry
    AuthService.storeUserInfo({ email });

    // Login via FB

    dispatch({
      type: ProfileTypes.IS_API_PROGRESS,
      payload: true,
    });

    AuthAPIService.fbLogin({
      accessToken: fbToken,
    })
      .then(data => {
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
        if (data) {
          const {
            cookie: { accessToken, expiry },
          } = data;
          AuthService.setAuthToken({ accessToken, expiry });

          // Login Success Sending metrics
          TelemetryService.sendEvent([
            TelemetryConstants.ONBOARDING,
            TelemetryConstants.LOGIN_OPTION,
            TelemetryConstants.FB_LOGIN_SUCCESS,
          ]);

          const prefs = UserPrefService.readPref();
          const locale = get(state, 'selectedLanguage.value') || get(prefs, 'language');
          const education = get(state, 'qualification') || get(prefs, 'selectedEducation');
          const salary = get(state, 'selectedSalary', 0) || get(prefs, 'salary', 0);

          if (locale && education && salary) {
            updateProfile(
              {
                userInformation: {
                  locale,
                  education,
                  minSalary: parseInt(salary, 10),
                  source: AppConstants.SOURCE,
                },
              },
              getOnBoardingStatus
            );
          } else {
            getOnBoardingStatus();
          }
          hideFacebookLoginLoader();
        }
      })
      .catch(error => {
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
        // Login FAILURE Sending metrics
        TelemetryService.sendEvent([
          TelemetryConstants.ONBOARDING,
          TelemetryConstants.LOGIN_OPTION,
          TelemetryConstants.FB_FAILED,
        ]);
        setProfileError(error, false);
        hideFacebookLoginLoader();
      });
  }
  function handleProceedWithMobile() {
    TelemetryService.sendEvent([
      TelemetryConstants.ONBOARDING,
      TelemetryConstants.LOGIN_OPTION,
      TelemetryConstants.MOBILE_AUTH_CLICK,
    ]);
    _resetError();
    RoutingService.gotoOnboardMobileInput();
  }
  function onSubmitMobile(options, cb) {
    dispatch({
      type: ProfileTypes.IS_API_PROGRESS,
      payload: true,
    });
    AuthAPIService.authLogin({
      phoneNumber: `${options.userMobile}`,
    })
      .then(() => {
        dispatchAPIProgress(false);
        TelemetryService.setUser();
        cb && cb(options);
      })
      .catch(() => {
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
      });
  }
  function onChangeMobile(mobile) {
    dispatch({
      type: ProfileTypes.ON_ENTER_MOBILE,
      payload: mobile,
    });
  }
  function submitOtp(otp, cb) {
    dispatch({
      type: ProfileTypes.IS_API_PROGRESS,
      payload: true,
    });

    AuthAPIService.authOTP({
      phoneNumber: `${state.mobile}`,
      otp: otp || `${state.otp}`,
      name: state.userName,
    })
      .then(data => {
        if (data) {
          const {
            cookie: { accessToken, expiry },
          } = data;
          if (accessToken) AuthService.setAuthToken({ accessToken, expiry });
        }
        return fetchUserInfo();
      })
      .then(userData => {
        dispatch({ type: ProfileTypes.UPDATE_USER_DETAILS, payload: userData });
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
        TelemetryService.setUser();
        cb && cb();
      })
      .catch(error => {
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
        setProfileError(error, false);
      });
  }

  function fbUserUpdatePhoneNumber(otp, cb) {
    dispatch({
      type: ProfileTypes.IS_API_PROGRESS,
      payload: true,
    });
    AuthAPIService.fbUserUpdatePhoneNumber({
      phoneNumber: `${state.mobile}`,
      otp: otp || `${state.otp}`,
    })
      .then(data => {
        if (data) {
          const {
            cookie: { accessToken, expiry },
          } = data;
          if (accessToken) AuthService.setAuthToken({ accessToken, expiry });
        }
        return fetchUserInfo();
      })
      .then(userData => {
        dispatch({ type: ProfileTypes.UPDATE_USER_DETAILS, payload: userData });
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
        TelemetryService.setUser();
        cb && cb();
      })
      .catch(error => {
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
        setProfileError(error, false);
      });
  }
  function deleteUser() {
    dispatch({
      type: ProfileTypes.IS_API_PROGRESS,
      payload: true,
    });
    AuthAPIService.deleteUser({
      phoneNumber: `${state.userMobile}`,
    })
      .then(data => {
        console.log(data);
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
        RoutingService.gotoOnboardLanguageSelection();
      })
      .catch(error => {
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
        setProfileError(error, false);
      });
  }

  function authUserBottomLogin(otp, cb) {
    dispatch({
      type: ProfileTypes.IS_API_PROGRESS,
      payload: true,
    });
    AuthAPIService.authOTP({
      phoneNumber: `${state.mobile}`,
      otp: otp || `${state.otp}`,
    })
      .then(data => {
        if (data) {
          const {
            cookie: { accessToken, expiry },
          } = data;
          if (accessToken) AuthService.setAuthToken({ accessToken, expiry });
        }
        return fetchUserInfo();
      })
      .then(userData => {
        dispatch({ type: ProfileTypes.UPDATE_USER_DETAILS, payload: userData });
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
        TelemetryService.setUser();
        cb && cb();
      })
      .catch(error => {
        dispatch({
          type: ProfileTypes.IS_API_PROGRESS,
          payload: false,
        });
        setProfileError(error, false);
      });
  }

  function onChangeOTPBottomLogin(otp, cb) {
    const { error } = state;
    if (!isEmpty(error)) _resetError();
    if (`${otp}`.length === 4) {
      dispatch({
        type: ProfileTypes.ON_ENTER_OTP,
        payload: otp,
      });
      setTimeout(() => {
        const isAuthenticated = Boolean(AuthService.getUserID());
        if (isAuthenticated) {
          fbUserUpdatePhoneNumber(otp, cb);
        } else {
          authUserBottomLogin(otp, cb);
        }
      }, 300);
    } else {
      dispatch({
        type: ProfileTypes.ON_ENTER_OTP,
        payload: otp,
      });
    }
  }

  return {
    setProfileError,
    setProfileInfo,
    setProfileSuccessMessage,
    onSelectPreferredLanguage,
    onChangeUserName,
    onSubmitUserName,
    onSelectGender,
    onChangeMobileNumber,
    onResendOTP,
    onSubmitMobileNumber,
    onChangeOTPInput,
    onSubmitOTP,
    fbUserUpdatePhoneNumber,
    onChangeUserAge,
    onSubmitAge: handleAgeSubmission,
    onSelectCity,
    setSelectedCity,
    onSelectCityByLocation,
    onSelectQualification,
    onSubmitQualification,
    onSelectJobDuration,
    onSubmitJobDuration,
    onSelectJobCategories,
    onSubmitJobCategories,
    getOnBoardingStatus,
    onSelectJobLocalities,
    onSubmitLocalities,
    onSelectHomeCity,
    onSelectHomeByLocation,
    onSubmitWorkExperience,
    onContinueWorkExp,
    onSelectMaritalStatus,
    onSelectSkill,
    onSubmitSkills,
    onSelectJobType,
    onSelectJobPref,
    onSubmitJobPref,
    onSelectLocalityByLocation,
    uploadProfilePicture,
    getUserProfile,
    toggleEdit,
    toggleWarning,
    updateProfile,
    uploadDocument,
    submitDocument,
    fetchJobCategories,
    fetchRequirements,
    onSalarySelected,
    onChangeGender,
    submitUserDetails,
    resetUserDetails,
    showLoginOption,
    hideLoginOption,
    handleFacebookLogin,
    showFacebookLoginLoader,
    hideFacebookLoginLoader,
    handleProceedWithMobile,
    onSubmitMobile,
    onChangeMobile,
    onChangeOTPBottomLogin,
    submitOtp,
    deleteUser,
  };
}
